module.exports = function (container) {
  return "\n    <div class=\"game-clock\">\n      <span id=\"game-clock-hours\">0</span>:<span id=\"game-clock-minutes\">00</span>:<span id=\"game-clock-seconds\">00</span>\n    </div>\n  ";
};